import {
  ColumnHeaderType,
  CreateMarketActivityFilterType,
  EmployeeResultType,
  LocationFilterInitialState,
  LoggedUserType,
  MarketingActivityListResultType,
  SetMarketActivityFilterType,
  SuggestionsType,
  UserType,
} from '../../utils/Types';
import {
  blankValueGetter,
  formattedDateWithFormat,
  getLocationValues,
  isAPIFailed,
  isAPISuccess,
} from '../../utils/Util';
import {
  CLICK_ACTIONS,
  MARKET_ACTIVITY_FILTER_INIT,
} from '../../utils/Constant';
import { toast } from 'react-toastify';
import {
  addAssignees,
  approveOrReject,
  changePrimaryEmployee,
  createMarketingActivity,
  getEmployeeList,
  getMarketingActivityDetails,
  removeAssinee,
} from '../../features/marketingActivitySlice';
import { ThunkDispatch } from 'redux-thunk';
import {
  saveCommentNote,
  updateCandidateName,
} from '../../features/onboardingSlice';
import { fetchVillagesOfDistricts } from '../../features/locationFilterSlice';
import moment from 'moment';
import { getCandidateDetails } from '../../features/assignGridSlice';
import { STATE_ACCESS_ROLES } from '../../utils/RBAC';

export const MARKETING_STATUSES = {
  NEW: 29,
  ASSIGNED: 30,
  INPROGESS: 31,
  REVIEW_PENDING: 32,
  COMPLETED: 33,
  REJECTED: 34,
};
export const getActivityClassName = (data: any) => {
  const value = data['activityStatusId' as keyof any];
  if (value == MARKETING_STATUSES.ASSIGNED) {
    return 'text-primary hide-text-decoration hide-deoration';
  } else if (value == MARKETING_STATUSES.INPROGESS) {
    return 'text-warning hide-text-decoration hide-deoration';
  } else if (value == MARKETING_STATUSES.REVIEW_PENDING) {
    return 'text-warning';
  } else if (value == MARKETING_STATUSES.COMPLETED) {
    return 'text-success';
  } else if (value == MARKETING_STATUSES.REJECTED) {
    return 'text-danger hide-text-decoration hide-deoration';
  } else {
    return 'text-dark hide-text-decoration hide-deoration';
  }
};

export const AssigneeColumnHeader: ColumnHeaderType[] = [
  {
    name: 'Employee Name',
    field: 'employeeName',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Employee Id',
    field: 'employeeUniqueId',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Email',
    field: 'email',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Role',
    field: 'roleName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'mobileNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'City / Village',
    field: 'cityId',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'city',
          data[field as keyof any],
          locationData,
          data['districtId']
        );
      else return '-';
    },
  },
  {
    name: 'Set Primary',
    field: '',
    radio: true,
    clickable: true,
    action: CLICK_ACTIONS.SET_PRIMARY_ASSIGNEE,
  },
];

export const AssignedEmpColumnHeader: ColumnHeaderType[] = [
  {
    name: 'Employee Name',
    field: 'fullName',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Employee Id',
    field: 'employeeUniqueId',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Email',
    field: 'emailId',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Role',
    field: 'roleName',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'mobileNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'City / Village',
    field: 'city',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'city',
          data[field as keyof any],
          locationData,
          data['district']
        );
      else return '-';
    },
  },
  {
    name: 'Is Primary',
    field: 'isPrimary',
    showTickMark: true,
  },
];

export const ViewActivitiesColumnsHeaders: ColumnHeaderType[] = [
  {
    name: 'Sales Id',
    field: 'activityUniqueId',
    sortable: false,
    valueGetter: blankValueGetter,
    action: CLICK_ACTIONS.UPDATE_MARKETING_ACTIVITY,
    clickable: true,
  },
  {
    name: 'Zone',
    field: 'zone',
    sortable: false,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'zone',
          data[field as keyof any],
          locationData
        );
      else return '-';
    },
  },
  {
    name: 'State',
    field: 'state',
    sortable: false,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'state',
          data[field as keyof any],
          locationData,
          data['zone']
        );
      else return '-';
    },
  },
  {
    name: 'District',
    field: 'district',
    sortable: false,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'district',
          data[field as keyof any],
          locationData,
          data['state']
        );
      else return '-';
    },
  },
  {
    name: 'City / Village',
    field: 'city',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'city',
          data[field as keyof any],
          locationData,
          data['district']
        );
      else return '-';
    },
  },
  {
    name: 'Activity Date & Time',
    field: 'activityStartDate',
    sortable: false,
    valueGetter: (data: any, field?: string) => {
      return formattedDateWithFormat(
        String(data[field as keyof any]),
        'DD-MM-YYYY hh:mm A'
      );
    },
  },
  {
    name: 'Status',
    field: 'activityStatusName',
    sortable: false,
    valueGetter: blankValueGetter,
    classNameGetter: getActivityClassName,
    clickable: true,
    action: CLICK_ACTIONS.REVIEW_MARKETING_ACTIVITY,
  },
];

export const UpdateAssigneeColumnHeader: ColumnHeaderType[] = [
  {
    name: 'Employee Name',
    field: 'employeeName',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Employee Id',
    field: 'employeeUniqueId',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Email',
    field: 'email',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Role',
    field: 'roleName',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'Contact Number',
    field: 'mobileNumber',
    sortable: false,
    valueGetter: blankValueGetter,
  },
  {
    name: 'City / Village',
    field: 'cityId',
    sortable: false,
    toolTipAfter: 25,
    valueGetter: (
      data: any,
      field?: string,
      locationData?: LocationFilterInitialState
    ) => {
      if (locationData)
        return getLocationValues(
          'city',
          data[field as keyof any],
          locationData,
          data['districtId']
        );
      else return '-';
    },
  },
  {
    name: 'Set Primary',
    field: 'setPrimary',
    clickable: true,
    value: 'Set Primary',
    action: CLICK_ACTIONS.SET_PRIMARY_ASSIGNEE,
    successIcon: true,
  },
  {
    name: 'Remove',
    field: '',
    clickable: true,
    value: 'Remove',
    action: CLICK_ACTIONS.REMOVE_ASSIGNEE,
    classNameGetter: () => {
      return 'text-danger';
    },
  },
];

export const listTypes = {
  create: 'CREATE',
  review: 'VIEW',
  update: 'UPDATE',
};

export const moduleIds = {
  seasons: 1,
  years: 5,
  marketingTypes: 6,
  status: 8,
};

export const blankCreatedActivity = {
  result: {
    marketingActivityResponse: {
      id: '',
      year: '',
      season: '',
      zone: '',
      state: '',
      district: '',
      city: '',
      type: '',
      activityDateTime: '',
      comments: '',
    },
    employeeMarketingActivityDetailsList: [],
  },
};

export const mockMarketingActivity = {
  activityUniqueId: 'MA-120824-4-33-00010',
  financialYearName: '2024-2025',
  seasonName: 'Rabi',
  activityTypeName: 'Campaign',
  activityStartDate: '2024-08-26T18:30:00',
  zoneName: 'South Zone',
  stateName: 'State A',
  districtName: 'District X',
  cityName: 'City Y',
  pincode: '123456',
  employeeList: [
    {
      id: null,
      candidateId: 9,
      candidateUniqueId: '1100110008',
      employeeUniqueId: '1100110008',
      fullName: 'South Zone Head ',
      photo: null,
      mobileNumber: 6666666668,
      emailId: 'fatest4@kshema.co',
      zone: 4,
      state: 36,
      district: 518,
      city: 87628,
      pincode: 500081,
      roleId: '4',
      roleName: 'Zonal Head',
      isPrimary: true,
    },
  ],
  notes: [{ notesDescription: 'Note 1', createdAt: '2024-08-18T12:00:00Z' }],
  images: [
    {
      id: 1,
      mediaPath: 'https://example.com/image',
    },
  ],
};

export const marketingActivityListRequest = (
  currentPage: number,
  pageSize: number,
  filterValues: SetMarketActivityFilterType,
  userDetails: UserType,
  user: LoggedUserType
) => {
  let zone = Number(filterValues.zone);
  if (
    !zone &&
    STATE_ACCESS_ROLES.includes(user?.roleId) &&
    userDetails?.reportingZones?.length
  ) {
    zone = Number(userDetails?.reportingZones[0]);
  }
  return {
    pageNumber: currentPage,
    pagePerCount: pageSize,
    activityUniqueId: filterValues?.activityId,
    financialYear: filterValues.year,
    season: filterValues.season,
    status: Number(filterValues.status) || null,
    zone: zone || null,
    state: Number(filterValues.state) || null,
    district: Number(filterValues.district) || null,
    city: Number(filterValues.village) || null,
  };
};

export const getDistrictsWithNoVillages = (
  activityData: MarketingActivityListResultType[],
  locationData: LocationFilterInitialState
) => {
  const districtIds = Array.from(
    new Set(activityData.map((activity) => Number(activity.district)))
  );
  const existingDistrictVillages = Object.keys(locationData.cityOptions).map(
    (key) => Number(key)
  );
  const districtsWithNoVillages = districtIds.filter(
    (id) => !existingDistrictVillages.includes(id)
  );
  return districtsWithNoVillages;
};

export const getActivityDetails = (
  dispatch: ThunkDispatch<any, any, any>,
  selectedActivity: any,
  setShowLoader: (value: boolean) => void,
  setActivityDetails: (value: any) => void
) => {
  try {
    dispatch(
      getMarketingActivityDetails({ activityUniqueId: selectedActivity })
    )
      .then((fulfilled) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
          setActivityDetails(null);
        } else if (isAPISuccess(fulfilled.payload)) {
          setActivityDetails(fulfilled.payload.result);
        }
      })
      .catch(() => {
        setShowLoader(false);
        toast.error('Fetching Marketing Activities Failed!');
        setActivityDetails(null);
      });
  } catch (e) {}
};
export const handleAction = (
  params: {
    action: any;
    activityDetails: any;
    comment: any;
    setShowLoader: (value: boolean) => void;
  },
  dispatch: ThunkDispatch<any, any, any>,
  setShowApproveSuccess: (value: boolean) => void,
  requestActivityDetails: () => void,
  getMarketingActivities: () => void,
  setOpenViewModal: (arg0: (prevState: any) => boolean) => void,
  setSelectedActivity: (value: any) => void
) => {
  const { action, activityDetails, comment, setShowLoader } = params;
  const data: any = {
    marketingActivityId: activityDetails?.marketingActivityId,
    comments: comment,
    status: action === CLICK_ACTIONS.REJECT ? 1 : 0,
  };
  setShowLoader(true);
  dispatch(approveOrReject(data))
    .then((fulfilled: any) => {
      setShowLoader(false);
      if (isAPIFailed(fulfilled.payload)) {
        toast.error(fulfilled.payload.responseInformation.responseMessage);
      } else if (isAPISuccess(fulfilled.payload)) {
        if (action === CLICK_ACTIONS.APPROVE) {
          setShowApproveSuccess(true);
          requestActivityDetails();
        } else if (action === CLICK_ACTIONS.REJECT) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
        }
        getMarketingActivities();
        setOpenViewModal((prevState: any) => !prevState);
        setSelectedActivity(undefined);
      }
    })
    .catch(() => {
      setShowLoader(false);
      toast.error('Approve or reject failed!');
    });
};

export const saveComment = (
  comment: string,
  selectedActivity: any,
  setShowLoader: (value: boolean) => void,
  setComment: (value: string) => void,
  setActivityDetails: (value: any) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (comment.trim()) {
    const data = {
      notesDescription: comment,
      module: 8,
      referenceId: selectedActivity.marketingActivityId,
    };
    setShowLoader(true);
    dispatch(saveCommentNote(data))
      .then((fulfilled: any) => {
        if (isAPIFailed(fulfilled.payload)) {
          toast.error(fulfilled.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled.payload)) {
          toast.success(fulfilled.payload.responseInformation.responseMessage);
          getActivityDetails(
            dispatch,
            selectedActivity?.activityUniqueId,
            setShowLoader,
            setActivityDetails
          );
        }
        setShowLoader(false);
      })
      .catch(() => {
        toast.error('Comment add failed!');
        setShowLoader(false);
      });
    setComment('');
  } else {
    toast.error('Please enter the comment');
  }
};

export const removeEmployee = (
  activityDetails: any,
  employeeId: number | string,
  setShowLoader: (param: boolean) => void,
  setActivityDetails: (data: any) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  setShowLoader(true);
  dispatch(
    removeAssinee({
      marketingActivityId: activityDetails.marketingActivityId,
      candidateId: employeeId,
    })
  ).then((fulfilled) => {
    if (isAPIFailed(fulfilled.payload)) {
      toast.error(fulfilled.payload.responseInformation.responseMessage);
    } else if (isAPISuccess(fulfilled.payload)) {
      toast.success(fulfilled.payload.responseInformation.responseMessage);
      getActivityDetails(
        dispatch,
        activityDetails.activityUniqueId,
        setShowLoader,
        setActivityDetails
      );
    }
    setShowLoader(false);
  });
};

export const updateMarketingActivity = (
  activityId: number | string,
  selectedEmployees: any,
  assignedEmployeeIds: (number | string)[],
  setShowLoader: (param: boolean) => void,
  setUpdateActivity: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  const assignees: any = [];
  const newAssignees = selectedEmployees.filter(
    (emp: any) => !assignedEmployeeIds.includes(emp.value)
  );
  newAssignees.map((assignee: any) => {
    assignees.push({
      candidateId: assignee.value,
      isPrimary: false,
    });
  });

  setShowLoader(true);
  dispatch(
    addAssignees({
      marketingActivityId: activityId,
      listOfEmployees: assignees,
    })
  ).then((fulfilled) => {
    if (isAPIFailed(fulfilled.payload)) {
      toast.error(fulfilled.payload.responseInformation.responseMessage);
    } else if (isAPISuccess(fulfilled.payload)) {
      toast.success(fulfilled.payload.responseInformation.responseMessage);
    }
    setShowLoader(false);
    setUpdateActivity(false);
  });
};

export const changePrimaryEmp = (
  empId: number | string,
  activityUniqueId: string,
  activityId: string | number,
  setShowLoader: (param: boolean) => void,
  setActivityDetails: (data: any) => void,
  dispatch: ThunkDispatch<any, any, any>
) => {
  setShowLoader(true);
  dispatch(
    changePrimaryEmployee({
      marketingActivityId: activityId,
      candidateId: empId,
    })
  ).then((fulfilled) => {
    if (isAPIFailed(fulfilled.payload)) {
      toast.error(fulfilled.payload.responseInformation.responseMessage);
    } else if (isAPISuccess(fulfilled.payload)) {
      toast.success(fulfilled.payload.responseInformation.responseMessage);
      getActivityDetails(
        dispatch,
        activityUniqueId,
        setShowLoader,
        setActivityDetails
      );
    }
    setShowLoader(false);
  });
};

export const onSelectEmployeeChange = (
  selectedEmployees: SuggestionsType[],
  employeeList: EmployeeResultType[],
  primaryEmpUniqueId: any,
  setPrimaryEmpUniqueId: (value: any) => void,
  setSelectedEmployeesDetails: (value: EmployeeResultType[]) => void
) => {
  const empsObj: EmployeeResultType[] = [];
  if (selectedEmployees.length) {
    const selectedUniqueIds: (string | number)[] = selectedEmployees.map(
      (option: SuggestionsType) => option.value
    );

    for (const element of employeeList) {
      if (selectedUniqueIds.includes(element.employeeId)) {
        empsObj.push(element);
      }
    }
    if (!selectedUniqueIds.includes(primaryEmpUniqueId)) {
      setPrimaryEmpUniqueId(null);
    }
  } else if (primaryEmpUniqueId) {
    setPrimaryEmpUniqueId(null);
  }
  setSelectedEmployeesDetails(empsObj);
};

export const getMarketingActivityOnIdChange = (
  createdActivityId: string | number | undefined,
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setCreatedActivity: (value: any) => void
) => {
  if (createdActivityId) {
    setShowLoader(true);
    dispatch(
      getMarketingActivityDetails({ activityUniqueId: createdActivityId })
    )
      .unwrap()
      .then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled)) {
          toast.error(fulfilled?.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled)) {
          setCreatedActivity(fulfilled.result);
        }
      })
      .catch(() => {
        setShowLoader(false);
        toast.error('Fetching Marketing Activities Failed!');
      });
  }
};

export const getVillages = (
  employeeList: any,
  locationData: any,
  dispatch: ThunkDispatch<any, any, any>
) => {
  if (employeeList?.length) {
    const districtIds: number[] = Array.from(
      new Set(employeeList.map((employee: any) => Number(employee.districtId)))
    );
    const existingDistrictVillages = Object.keys(locationData.cityOptions).map(
      (key) => Number(key)
    );
    const districtsWithNoVillages = districtIds.filter(
      (id) => !existingDistrictVillages.includes(id)
    );
    if (districtsWithNoVillages.length) {
      dispatch(
        fetchVillagesOfDistricts({
          districtId: districtsWithNoVillages,
        })
      );
    }
  }
};

export const onSubmitFilter = (
  isValid: boolean,
  filterValues: any,
  setShowAssignees: (value: boolean) => void,
  setFilterData: any,
  dispatch: ThunkDispatch<any, any, any>,
  setSelectedEmployees: (value: SuggestionsType[]) => void
) => {
  if (isValid) {
    setShowAssignees(true);
    setFilterData((prev: any) => ({
      ...prev,
      ...filterValues,
    }));
    dispatch(
      getEmployeeList({
        zoneId: filterValues.zone,
        stateId: filterValues.state,
      })
    );
    setSelectedEmployees([]);
  } else {
    setShowAssignees(false);
    setFilterData(MARKET_ACTIVITY_FILTER_INIT);
  }
};

export const createObj = (
  selectedEmployees: any,
  primaryEmpUniqueId: any,
  filterData: any,
  activityDate: any
) => {
  const selectedEmployeesArr: any[] = [];
  selectedEmployees.map((emp: any) => {
    selectedEmployeesArr.push({
      candidateId: emp.value,
      isPrimary: emp.value === primaryEmpUniqueId,
    });
  });

  return {
    financialYear: filterData?.year,
    season: filterData?.season,
    zone: filterData?.zone,
    state: Number(filterData?.state),
    city: Number(filterData?.village),
    district: Number(filterData?.district),
    listOfEmployees: selectedEmployeesArr,
    activityTypeId: filterData?.marketingActivityType,
    activityStartDate: moment(activityDate, 'DD-MM-YYYY H:mm A').toISOString(),
    comments: filterData?.comment ?? '',
    activityEndDate: new Date(
      moment(activityDate, 'DD-MM-YYYY H:mm').format('DD MMM YYYY H:mm')
    ).toISOString(),
    pincode: filterData?.pincode,
  };
};
export const handleCreate = (
  params: {
    activityDate: string;
    selectedEmployees: SuggestionsType[];
    filterData: CreateMarketActivityFilterType | undefined;
    primaryEmpUniqueId: any;
  },
  setShowLoader: (param: boolean) => void,
  dispatch: ThunkDispatch<any, any, any>,
  setCreatedActivityId: (value: string | number) => void,
  setOpenSuccessModal: (value: boolean) => void
) => {
  let isValid = true;
  const { activityDate, selectedEmployees, filterData, primaryEmpUniqueId } =
    params;
  const isInPast = moment(activityDate, 'DD-MM-YYYY H:mm A').isBefore(
    moment().startOf('minute')
  );

  if (!selectedEmployees.length) {
    toast.error('Please assign the employees');
    isValid = false;
  } else if (!filterData?.marketingActivityType) {
    toast.error('Type of Sales Activity is required');
    isValid = false;
  } else if (!activityDate) {
    toast.error('Activation Date & Time  is required');
    isValid = false;
  } else if (isInPast) {
    toast.error('Activity Date & Time should be in future');
    isValid = false;
  } else if (!primaryEmpUniqueId) {
    toast.error('Primary employee is required');
    isValid = false;
  }
  if (isValid) {
    setShowLoader(true);
    dispatch(
      createMarketingActivity(
        createObj(
          selectedEmployees,
          primaryEmpUniqueId,
          filterData,
          activityDate
        )
      )
    )
      ?.then((fulfilled: any) => {
        setShowLoader(false);
        if (isAPIFailed(fulfilled?.payload)) {
          toast.error(fulfilled?.payload.responseInformation.responseMessage);
        } else if (isAPISuccess(fulfilled?.payload)) {
          setCreatedActivityId(fulfilled?.payload.result);
          setOpenSuccessModal(true);
        }
      })
      ?.catch(() => {
        setShowLoader(false);
        toast.error('Sales Activity creation failed!');
      });
  }
};
export const saveCandidateName = (
  firstName: string,
  lastName: string,
  candidateId: any,
  loggedCandidateID: any,
  dispatch: ThunkDispatch<any, any, any>,
  refreshData: () => void,
  setShowLoader: (value: boolean) => void
) => {
  const data = {
    lastName: lastName.trim(),
    firstName: firstName.trim(),
    candidateId: candidateId,
  };
  console.log('data', data);
  dispatch(updateCandidateName(data))
    .then(async (fulfilled: any) => {
      console.log('fulfilled', fulfilled);
      if (isAPIFailed(fulfilled?.payload)) {
        if (fulfilled?.payload?.responseInformation?.responseMessage) {
          toast.error(fulfilled?.payload.responseInformation.responseMessage);
        }
      } else if (isAPISuccess(fulfilled?.payload)) {
        toast.success(fulfilled?.payload.responseInformation.responseMessage);
        await dispatch(getCandidateDetails(candidateId));
        await refreshData();
        setShowLoader(false);
      } else if (fulfilled?.payload?.message) {
        toast.error(fulfilled?.payload?.message);
      }
    })
    .catch(() => {
      toast.error('Candidate name update failed!');
    });
};
